import {Dispatchable} from "../../../stem-core/src/base/Dispatcher.js";
import {iFrameConnection} from "../../services/IFrameConnection.js";
import {IFrameMessages} from "../../../blink-sdk/messaging/IFrameMessages.js";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../../blink-sdk/utils/AnalyticsClient.js";
import {Router} from "../../../stem-core/src/ui/Router.jsx";
import {iFrameState} from "../../services/IFrameState.js";
import {GATE_TYPE} from "../../../blink-sdk/Constants.js";
import {startFlow} from "./FlowEntrypoint.js";


export function sendFlowCheckpoint(flowType, flowCheckpoint, payload, extra) {
    dispatchAnalyticsEvent(AnalyticsEventType.FLOW_CHECKPOINT, {flowType, flowCheckpoint, ...payload});
    iFrameConnection.sendToSDK(IFrameMessages.FLOW_CHECKPOINT, {
        event: {
            flowType,
            flowCheckpoint,
            ...payload,
        },
        extra,
    });
}


export class BaseFlowHandler extends Dispatchable {
    // Called when the panel is instantiated with this flow.
    async start() {
        Router.changeToCustomPanel();
    }

    // Called when an action button of this type is clicked. It might be from a different panel type.
    onActionButtonClick(event) {
        event.preventDefault();
        event.stopPropagation();
        event.returnValue = false;

        const {gateType, inlineFlow} = iFrameState;

        if (gateType === GATE_TYPE.popup || inlineFlow) {
            // Just continue the flow here, we're already in a popup
            iFrameState.iframeParams.skipCTA = true;
            this.start();
        } else {
            // Start a flow independently from this panel
            startFlow(this.panelType, {
                skipCTA: true,
            })
        }
    }

    // Called after the user signs is from a PanelFooter of this type ("Already a user/subscriber/etc? Log in")
    afterLoginFromFooter(event) {
        this.onActionButtonClick(event);
    }
}

